<div class="msp-table-sort-dropdown-container" [ngClass]="{ open: openDropdown }">
	@if (headerData.colType === 'text' || headerData.colType === 'date') {
		<div class="search-container">
			<input
				[type]="headerData.colType"
				[value]="search.values[0]"
				[(ngModel)]="search.values[0]"
				(ngModelChange)="dirtySearch = true"
				(keydown.enter)="doSearch(); toggleDropdown()" />
			<button class="search-button" (click)="doSearch(); toggleDropdown()">
				<fa-icon [icon]="icons.faMagnifyingGlass"></fa-icon>
			</button>
		</div>
	}

	@if (headerData.colType === 'multi-select' || headerData.colType === 'boolean') {
		<div class="header-dropdown">
			<div class="search-container">
				<input type="text" [(ngModel)]="search.filter" />
				<button class="search-button" (click)="doSearch(); toggleDropdown()">
					<fa-icon [icon]="icons.faMagnifyingGlass"></fa-icon>
				</button>
			</div>
			<div class="option-container">
				<div class="option" (click)="toggleSelectAll(); dirtySearch = true">
					<input type="checkbox" [checked]="allSelected()" />
					<span>{{ labels.lbl_geral_selecionar_todos }}</span>
				</div>
				@for (item of headerData.items | callback: filterSearchOptions; let itemIndex = $index; track item) {
					<div class="option" [class.disabled]="item.disabled" (click)="toggleSelectItem(item); dirtySearch = true">
						<input type="checkbox" [checked]="item.selected" />
						<span>{{ labels[item.label] ? labels[item.label] : item.label }}</span>
					</div>
				}
			</div>
		</div>
	}
</div>
